(function(){
    angular
        .module('app')
        .directive('ngSelect2', select2);

        select2.$inject = ['$timeout'];
        function select2($timeout){
            return {
              require: 'ngModel',
              scope:{
                ngModel:"=",
                options:"="
              },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                  var options = {};
                  if(scope.options){
                    options = scope.options;
                  }
                   options.placeholder = $attrs.placeholder || "Seleccionar"; // Placeholder por defecto si no se define
                  var valorrel = "";
                    var value = $attrs.value;
                    var $element = $(element);
                    var name = $element.attr("id");
                    var valuesArray = [];
        
                    $element.select2(options);
                    $element.on("select2:select", function (evt) {
                        var elementVar = evt.params.data.element;
                        var $elementVar = $(elementVar);
                        ngModel.$setViewValue($element.val());
                      });

                    function cambiando(){
                      if(scope.ngModel==0){
                        $element.trigger('change.select2');
                      }
                    }

                    scope.$watch('ngModel', cambiando, true);

                });
            }
          }
      }
})();